import React, { useRef, useState } from 'react';
import {
    Box,
    Grid,
    Button,
    Dialog,
    IconButton,
    Divider,
    Typography,
    Stack,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { LoadingButton } from '@mui/lab';
import { Formik } from 'formik';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // Icono de éxito
import CancelIcon from '@mui/icons-material/Cancel'; 
import get from 'lodash/get';
import dayjs from 'dayjs';

import validator from "./validatorStateDeliveryPoint";
import DateTimePickerUi from '../../../components/form/DatePickerTimeUi';
import InputText from "../../../components/form/InputText";

const Alert = ({
    __,
    open,
    close,
    selected,
    onUpdate
}) => {

    const [openQuestion, setOpenQuestion] = useState({
        value: "",
        state: false
    });

    const [stateDeliveryPoint, setStatusDeliveryPoint] = useState("")

    const initialValues = {
        datePointDelivered:  dayjs().format("YYYY-MM-DDTHH:mm:ssZ"),
        comment: "",
    };

    const onSubmit = (values) => {
        let dateEstimate = get(values, "datePointDelivered");
        let comment = get(values, "comment");
        let updatedstatusDeliveryPoint = {};

        if (stateDeliveryPoint === 1 ) {

            updatedstatusDeliveryPoint = {
                ...selected, 
                statusId: 3,
                comment: comment,
                deliveryRealDate: dateEstimate
            };

            setStatusDeliveryPoint("");

        } else if (stateDeliveryPoint === 2 ) {

            updatedstatusDeliveryPoint = {
                ...selected, 
                statusId: 4,
                comment: comment,
                deliveryRealDate: dateEstimate 
            };

            setStatusDeliveryPoint("");
        } 

        //console.log("entre al submit ", updatedstatusDeliveryPoint)
      onUpdate(updatedstatusDeliveryPoint);
       close();
    }

    const getQuestionDetail = () => {
        switch (openQuestion.value) {
            case 1:
                return __("alert.successDelivery"); // Texto para "Entregado"
            case 2:
                return __("alert.errorDelivery"); // Texto para "No entregado" 
        }
    };

    return (
        <div>
            <Dialog onClose={close} open={open} maxWidth="lg" fullWidth>
                <Box className='px-6'>
                    <Typography Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
                             {__(`labels.17`)}
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={close}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
                <div>
                    {!open
                        ? (
                            <Box sx={{ minHeight: 200, width: "100%" }} />
                        ) : (
                            <Formik initialValues={initialValues}
                                validationSchema={validator(__)}
                                onSubmit={onSubmit}>
                                {formik => (
                                    <form id="delivery-state-form" onSubmit={get(formik, "handleSubmit")}>
                                        <div className='relative'>
                                            <Divider />
                                            <Box className='p-4' >
                                                <Grid container spacing={{ xs: 2, md: 3 }}>
                                                    <Grid item xs={12} sm={6}>
                                                        <DateTimePickerUi
                                                            formik={formik}
                                                            name="datePointDelivered"
                                                            label={__(`form.datePointDelivered.label`)}
                                                            placeholder={__(`form.datePointDelivered.placeholder`)}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <InputText
                                                            formik={formik}
                                                            name="comment"
                                                            label={__(`form.comment.label`)}
                                                            placeholder={__(`form.comment.placeholder`)}
                                                            multiline
                                                            rows={3}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </div>
                                    </form>
                                )}
                            </Formik>
                        )}
                </div>
                <Box className='flex flex-row justify-center items-center m-6'  sx={{ gap: 2 }}>
                    <Button 
                        className='w-[200px] min-w-[200px]' 
                        variant='contained' 
                        sx={{ backgroundColor: '#4CAF50', color: 'white', '&:hover': { backgroundColor: '#45A049' } }}
                        type="submit"
                        form="delivery-state-form"
                        onClick={() => { setStatusDeliveryPoint(1) }} 
                        startIcon={<CheckCircleIcon />} 
                    >
                        Entregado
                    </Button>
                    <Button
                        className='w-[200px] min-w-[200px]' 
                        variant='contained' 
                        color="error"
                        type="submit"
                        form="delivery-state-form"
                        onClick={() => { setStatusDeliveryPoint(2) }}  
                        startIcon={<CancelIcon />}
                    >
                        No entregado
                    </Button>
                </Box>
            </Dialog>
        </div>
    )
 }

 export default Alert